import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {useMemo, useState, forwardRef, useImperativeHandle} from "react";

const FilesUpload = forwardRef(({ onFilesUploaded }, ref) => {
  const [files, setFiles] = useState([])

  useImperativeHandle(ref, () => {
    return {
      clearFiles() {
        setFiles([])
      },
    };
  }, []);

  // 提交前处理
  const beforeUpload = (file) => {
    const typeValid =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'video/mp4' ||
        file.type === 'application/pdf';

    if (!typeValid) {
      message.error('You can only upload JPG/PNG/PDF/MP4 file!');
    }

    const fileSize = file.size / 1024 / 1024;

    if ((file.type === 'image/jpeg' || file.type === 'image/png') && fileSize > 10) {
      message.error('Image must smaller than 10MB!');
    }else if(file.type === 'application/pdf' && fileSize > 10){
      message.error('PDF must smaller than 10MB!');
    }else if(file.type === 'video/mp4' && fileSize > 300){
      message.error('MP4 must smaller than 300MB!');
    }

    return typeValid;
  };

  // 文件列表变化处理
  const onFilesChange = ({ file, fileList }) => {
    if (
        file.response &&
        file.response.code !== '10000' &&
        fileList.length !== 0
    ) {
      message.error(
          file.response.msg || file.response.message || 'Upload failed'
      );
      fileList.forEach((_file) => {
        if (_file.uid === file.uid) {
          _file.status = 'error';
        }
      });
    }
    if (file.response && file.response.code === '10000') {
      message.success(file.response.msg);
    }
    if (!file.status) {
      fileList.forEach((_file) => {
        if (_file.uid === file.uid) {
          _file.status = 'error';
        }
      });
    }
    onFilesUploaded(fileList.filter((_file) => _file.status !== 'error'));
    setFiles(fileList)
  };

  // 定义上传事件配置项
  const UploadProps = useMemo(() => {
    return {
      action: process.env.REACT_APP_API_BASE + '/files/upload',
      onChange({ file, fileList }) {
        onFilesChange({ file, fileList });
      },
      defaultFileList: [],
      fileList: files,
      beforeUpload: beforeUpload,
      maxCount: 6,
      headers: {
        Authorization: `${localStorage.getItem('token')}`,
      },
    }
  }, [files, beforeUpload, onFilesChange]);

  return (
      <Upload {...UploadProps}>
        <Button type="text" icon={<UploadOutlined />}>
          Add attachment
        </Button>
      </Upload>
  );
});

export default FilesUpload;
